import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { getColumnDefinitions } from '../../shared/columnDefinitions/accountBalances';
import AgGrid from '../../shared/agGrid/agGrid.component';

import {
  accountBalancesPropTypes,
  groupTypePropTypes,
} from './viewAccountBalances.proptypes';

import { groupTypeValues } from '@common/constants/sharedConstants';

class AccountBalancesGrid extends PureComponent {
  static propTypes = {
    accountBalancesLoading: PropTypes.bool.isRequired,
    accountBalances: accountBalancesPropTypes,
    groupType: groupTypePropTypes,
  };

  // AgGrid doesn't add the no rows overlay automatically when grid
  // finishes loading with no data.
  onComponentStateChanged = ({ api }) => {
    const { accountBalances, accountBalancesLoading } = this.props;
    if (!accountBalances.length && !accountBalancesLoading) {
      api.showNoRowsOverlay();
    }
  };

  render() {
    const {
      accountBalances,
      accountBalancesLoading,
      groupType,
    } = this.props;

    const columnDefs = getColumnDefinitions(groupType?.value
      ? groupType?.value
      : groupTypeValues.COMPANY_CODES
    );

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <div className="row no-gutters">
          <div className="col">
            <h5>BSM Account Balances</h5>
          </div>
        </div>
        <AgGrid
          columnDefs={columnDefs}
          rowData={accountBalances}
          onComponentStateChanged={this.onComponentStateChanged}
          isGridLoading={accountBalancesLoading}
        />
      </div>
    );
  }
}

export default AccountBalancesGrid;
